import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewWarehouse from './ViewWarehouse';

const ScanWarehouse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const scannedId = location.state?.selectedRecordId;

  useEffect(() => {
    if (!scannedId) {
      navigate('/admin/warehouse-view');
    }
  }, [scannedId, navigate]);

  // If we have a scanned ID, show the ViewWarehouse component
  // which will automatically show the record details
  return <ViewWarehouse initialSelectedId={scannedId} />;
};

export default ScanWarehouse; 